import { Injectable } from "@angular/core";
import { HttpClientService } from "../httpClient/httpclient.service";

@Injectable()
export class AssociationsService {
  baseUrlUsers: string = "koncentro-auth/users/";
  baseUrlCompanies: string = "koncentro-auth/companies/";
  baseUrlApplications: string = "koncentro-auth/applications/";
  rowId: number;
  constructor(private http: HttpClientService) {}

  /**
   * Restituisce la lista di tutti gli utenti
   */
  getAllUsers(limit?: string, login?: string) {
    return this.http.get(this.baseUrlUsers+'?login='+ login + '&limit='+ limit );
  }

  /**
   * Restituisce la lista di tutte le Companies
   */
  getAllCompanies() {
    return this.http.get(this.baseUrlCompanies);
  }

  /**
   * Restituisce la lista di tutte le Applications
   */
  getAllApplications() {
    return this.http.get(this.baseUrlApplications);
  }

  /**
   * Metodo per ottenere la lista delle company di un utente
   * @returns
   */
  getUserCompanyAssociation(userId: number) {
    return this.http.get(this.baseUrlUsers + "all-company/" + userId);
  }

  getUserAppCompanyAssociation(companyId: number) {
    return this.http.get(
      this.baseUrlUsers + `all-app-company/${this.rowId}/${companyId}`
    );
  }

  /**
   * Restituisce le Applications associabili alla Company
   */
  getCompanyAppAssociation() {
    return this.http.get(this.baseUrlCompanies + 'all-app/' + this.rowId);
  }

  /**
   * Restituisce le Company associabili ad una Application
   */
  getAppCompanies() {
    return this.http.get(this.baseUrlApplications + 'all-company/' + this.rowId);
  }

  /**
   * Restituisce gli utenti associabili ad un application della company
   * @param applicationId
   * @returns
   */
  getCompanyAppUserAssociations(applicationId: number) {
    return this.http.get(this.baseUrlUsers + `all-app-user-company/${this.rowId}/${applicationId}`);
  }

  /**
   * Restituisce gli Utenti associabili ad una Company dell'Application
   */
  getAppCompanyUsers(companyId: number) {
    return this.http.get(this.baseUrlUsers + `all-app-user-company/${companyId}/${this.rowId}`);
  }

  /**
   * Metodo per la creazione di una associazione tra User e Company
   * @param data
   * @returns
   */
  createUserCompanyAssociation(data) {
    Object.assign(data, { user_id: this.rowId });
    return this.http.post(this.baseUrlUsers + "user_companies", data);
  }

  /**
   * Metodo per la modifica di una associazione tra User e Company
   * @param data
   * @returns
   */
  editUserCompanyAssociation(data) {
    Object.assign(data, { user_id: this.rowId });
    return this.http.put(this.baseUrlUsers + "user_companies/" + data.id, data);
  }

  /**
   * Metodo per eliminare un associazione tra User e Company
   * @param userCompanyId
   * @returns
   */
  deleteUserCompanyAssociation(companyId: number) {
    return this.http.delete(
      this.baseUrlUsers + `user_companies/${this.rowId}/${companyId}`
    );
  }

  /**
   * Metodo per creare relazione tra utente e appCompany
   * @param data
   */
  createUserAppCompanyAssociation(data) {
    Object.assign(data, { user_id: this.rowId });
    return this.http.post(this.baseUrlUsers + `user_companies_applications`, data);
  }

  /**
   * Metodo per modificare relazione tra utente e appCompany
   * @param data
   */
   editUserAppCompanyAssociation(data: any, appCompanyId: number) {
    Object.assign(data, { user_id: this.rowId });
    return this.http.put(this.baseUrlUsers + `user_companies_applications/${appCompanyId}`, data);
  }

  /**
   * Metodo per associare App a Company
   */
  createCompanyAppAssociation(data) {
    Object.assign(data, { companyId: this.rowId });
    return this.http.post(this.baseUrlCompanies + `company_applications`, data);
  }

  /**
   * Metodo per modificare msBaseUrl associazione App a Company
   */
  editCompanyAppAssociation(data: any, appId: number) {
    Object.assign(data, { companyId: this.rowId });
    return this.http.put(this.baseUrlCompanies + `company_applications/${appId}`, data);
  }

  /**
   * Metodo per associare User ad App
   */
  createAppUserAssociation(data) {
    Object.assign(data, { company_id: this.rowId });
    return this.http.post(this.baseUrlUsers + 'user_companies_applications', data);
  }

  /**
   * Metodo per modificare associzione User ad App
   */
   editAppUserAssociation(data: any, userApplicationCompanyId: number) {
    Object.assign(data, { company_id: this.rowId });
    return this.http.put(this.baseUrlUsers + 'user_companies_applications/' + userApplicationCompanyId, data);
  }

  /**
   * Metodo per associare User a Company
   */
  createCompanyUserAssociation(data: any) {
    Object.assign(data, { application_id: this.rowId });
    return this.http.post(this.baseUrlUsers + 'user_companies_applications', data);
  }

  /**
   * Metodo per modificare associazione User a Company
   */
   editCompanyUserAssociation(data: any, userId: number) {
    Object.assign(data, { application_id: this.rowId });
    return this.http.put(this.baseUrlUsers + 'user_companies_applications/' + userId, data);
  }

  /**
   * Associa Company ad App
   */
  createAppCompanyAssociation(companyId: number, msBaseUrl: string) {
    const data = {
      applicationId: this.rowId,
      companyId: companyId,
      msBaseUrl
    }
    return this.http.post(this.baseUrlCompanies + 'company_applications', data);
  }

  /**
   * Modifica associazione Company ad App
   */
  editAppCompanyAssociation(company: any, msBaseUrl: string) {
    const data = {
      applicationId: this.rowId,
      companyId: company.company_id,
      msBaseUrl
    }
    return this.http.put(this.baseUrlCompanies + 'company_applications/' + company.id, data);
  }

  /**
   * Metodo che elimina un associazione tra utente e appCompany
   */
  deleteUserAppCompanyAssociation(appCompanyId: number) {
    return this.http.delete(
      this.baseUrlUsers + `user_companies_applications/${this.rowId}/${appCompanyId}`
    );
  }

  /**
   * Metodo che elimina associazione di App a Company
   */
  deleteCompanyAppAssociation(appCompanyId: number, applicationId: number) {
    return this.http.delete(this.baseUrlCompanies + `company_applications/${appCompanyId}/${applicationId}`);
  }

  /**
   * Metodo che elimina associazione di User ad App
   */
  deleteAppUserAssociation(userId: number, appId: number) {
    return this.http.delete(this.baseUrlUsers + `user_companies_applications/${userId}/${appId}`)
  }

  /**
   * Elimina associazione di Company da App
   */
  deleteAppCompanyAssociation(companyId: number) {
    return this.http.delete(this.baseUrlCompanies + `company_applications/${companyId}/${this.rowId}`);
  }

  /**
   * Elimina associazione di User da Company
   */
  deleteCompanyUserAssociation(userId: number, companyId: number) {
    return this.http.delete(this.baseUrlUsers + `user_companies_applications/${userId}/${companyId}`)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/associations/associations.service.ts